import React, { useEffect, useState, useCallback } from 'react';
import { LoadScript, GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';

const apiEndpoint = '.';

export default function MapView({ center: initialCenter, isConnected, url }) {
  const [center, setCenter] = useState(initialCenter);
  const [accounts, setAccounts] = useState([]);
  const [mapKey, setMapKey] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);

  // Fetch Google Maps API key
  useEffect(() => {
    fetch(`${apiEndpoint}/config/google-maps-key`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch key');
        return res.json();
      })
      .then(({ key }) => setMapKey(key))
      .catch(err => {
        console.error('Failed to load Google Maps API key:', err);
        alert("Failed to load Google Maps.");
      });
  }, []);

  // Fetch accounts
  useEffect(() => {
    if (!center && !isConnected) return;
    console.log('MapView.js - BEFORE fetching accounts');
//    fetch(`${apiEndpoint}/accounts`, { credentials: 'include' })
//    fetch(`/accounts/nearby?lat=${center.lat}&lng=${center.lng}&radius=10`, { credentials: 'include' })

    fetch(`${apiEndpoint}/accounts/nearby?lat=${center.lat}&lng=${center.lng}&radius=10`, { credentials: 'include' })
      .then(res => {
        if (res.status === 401) {
          setAccounts([]);
        } else {
          console.log('client - MapView - Accounts returned');
          return res.json().then(setAccounts);
        }
      })
      .catch(err => console.error('Error fetching accounts:', err));
  }, [center, isConnected]);

  // Marker click handler
  const handleMarkerClick = useCallback((acc) => {
    setSelectedMarker(acc);
  }, []);

  // Map click handler (set new center)
  const handleMapClick = useCallback((event) => {
    const newCenter = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    };
    setCenter(newCenter);
  }, []);

  if (!mapKey) return <div>Loading map…</div>;
//        mapContainerStyle={{ width: '100%', height: '90vh' }}

  return (
    <LoadScript googleMapsApiKey={mapKey}>
      <GoogleMap
        center={center}
        zoom={12}
        mapContainerStyle={{ width: '100vw', height: 'calc(100vh - 56px)' }}
        onClick={handleMapClick}
      >
        {accounts.map(acc => {
          const lat = acc.Primary_GeoLocation__Latitude__s;
          const lng = acc.Primary_GeoLocation__Longitude__s;
          if (!lat || !lng) return null;
          return (
            <Marker
              key={acc.Id}
              position={{ lat, lng }}
              title={acc.Name}
              onClick={() => handleMarkerClick(acc)}
              options={{
                icon: {
                  url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless.png", // You can provide a custom icon URL here
                  //scaledSize: { width: 40, height: 40 }
                }
              }}
            />
          );
        })}
        {selectedMarker && (
          <InfoWindow
            position={{
              lat: selectedMarker.Primary_GeoLocation__Latitude__s,
              lng: selectedMarker.Primary_GeoLocation__Longitude__s
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div>
              <b>
                <a
                  href={`${url}/${selectedMarker.Id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {selectedMarker.Name}
                </a>
              </b>
              <br />
              {selectedMarker.Primary_GeoLocation__Latitude__s || ''}
              <br />
              {selectedMarker.Primary_GeoLocation__Longitude__s || ''}
              <a
                href={`salesforce1://sObject/${selectedMarker.id}/view`}
                target="_blank"
                rel="noopener noreferrer"
                                        >
              MOBILE: {selectedMarker.name}
              </a>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
}